module.exports = __webpack_public_path__ + "media/images/common/temp-51bd22e62b470e73dcf58c3a3ef9cb3d.png";